import { Routes } from 'app/services/routeService/routeService'
import { useCallback, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as R from 'ramda'
import {
  useIsInLimboPeriod,
  useIsAuthorized,
  useIsPlacePendingActivateHasAccess,
} from './authHooks'
import { useFlag } from '@unleash/proxy-client-react'
import { matchRoutes } from 'react-router-config'
import { useDispatch, useSelector } from 'react-redux'
import { autherRoleHavePlanEnd, logoutUser } from './store/actions'

const planAndBillingURL = (path) => {
  return R.includes(path, [
    Routes.billingOverview(),
    Routes.usageSummary(),
    Routes.usageHistory(),
    Routes.aiUsageLog(),
  ])
    ? path
    : Routes.billingOverview()
}

const notificationTimelineURL = Routes.notificationTimeline()

const AppLimboAccessControl = (props) => {
  const mes_3908_place_profile = useFlag('mes_3908_place_profile')

  const { children, routes, history, location } = props
  const isAuthorized = useIsAuthorized()
  const isInLimboPeriod = useIsInLimboPeriod()
  const pathName = R.prop('pathname', location)
  const isOwner = useSelector(R.path(['auth', 'user', 'data', 'isOwner']))
  const dispatch = useDispatch()

  const matched = R.head(matchRoutes(routes, pathName))
  const accesses = R.path(['route', 'accesses'], matched)

  const isSocialAuthRedirect =
    Routes.socialMediaIntegrationsBeewo() === pathName
  const isPendingActiveMenu = useIsPlacePendingActivateHasAccess(accesses)

  const profileInfoURL = mes_3908_place_profile
    ? Routes.profileInfoV4()
    : Routes.profileInfo()
  // const excludedURL = Routes.profileInfo() // isPendingActiveMenu ? Routes.dashboard() : Routes.profileInfo()

  const isShowDashboard = R.includes(process.env['REACT_APP_ENV'], [
    'dev',
    'qa',
    'prod',
  ])

  const pushPathname = useCallback(
    (input) => {
      history.push(input)
    },
    [history],
  )

  useEffect(() => {
    if (isSocialAuthRedirect) {
      return
    }

    if (
      isInLimboPeriod &&
      isAuthorized &&
      R.o(R.not, R.includes(pathName))(profileInfoURL)
    ) {
      if (isPendingActiveMenu) {
        pushPathname({
          pathname: profileInfoURL,
        })
      } else {
        if (isOwner) {
          pushPathname({
            pathname: planAndBillingURL(pathName),
          })
        } else {
          Promise.all([
            dispatch(logoutUser()),
            dispatch(autherRoleHavePlanEnd()),
          ])
        }
      }
    } else if (pathName === '/dashboard' && !isShowDashboard) {
      pushPathname({
        pathname: notificationTimelineURL,
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInLimboPeriod, pushPathname, pathName])

  return children
}

export default withRouter(AppLimboAccessControl)
